export default {"src":"/_next/static/media/signup.d1e56210.svg","height":320,"width":361,"blurWidth":0,"blurHeight":0};